import { createColumnHelper } from "@tanstack/table-core";
import type { PaymentModel } from "../../mobx/core/payment/model.payment";

export { getPaymentTableColumnAccessor } from "./column-accessors.js";
export { PAYMENT_COLUMN_CONFIGS } from "./column-config";
export { paymentMatchesGlobalFilter } from "./utils/payment-global-filter";
export {
  getPaymentStatusBadgeVariant,
  getPaymentStatusLabelKey,
} from "./utils/payment-status";
export type { PaymentTableColumnAccessor } from "./column-accessors.js";
export type { PaymentColumnConfig } from "./column-config";
export type { PaymentStatusBadgeVariant } from "./utils/payment-status";

export const paymentColumnHelper = createColumnHelper<PaymentModel>();
